import React from "react";
import { Dropdown } from "semantic-ui-react";

interface InspectionItemStaffPassedDropdownButtonProps {
  isFailLoading?: boolean;
  onFail?: () => void;
}
export default function InspectionItemStaffPassedDropdownButton({
  isFailLoading,
  onFail,
}: InspectionItemStaffPassedDropdownButtonProps) {
  return (
    <Dropdown button text='Passed' loading={isFailLoading} className='tw-bg-[#067E30] tw-text-[#fff]'>
      <Dropdown.Menu>
        <Dropdown.Item label={{ color: "red", empty: true, circular: true }} text='Failed' onClick={onFail} />
      </Dropdown.Menu>
    </Dropdown>
  );
}
